/* Mobile consent notice styling only; consent state and preferences are untouched. */
(() => {
  const styleId = 'beleaev-compact-consent';
  const css = "@media(max-width:749px){\n.dialog.notice.bar{--padding:10px!important;--font-size:12px!important}\n.dialog.notice.bar>.inner{padding:10px 12px!important;gap:5px!important}\n.dialog.notice.bar .header,.dialog.notice.bar .body,.dialog.notice.bar .intro,.dialog.notice.bar .links{margin:0!important;padding-block:0!important;gap:3px!important}\n.dialog.notice.bar .title,.dialog.notice.bar h2{font-size:14px!important;line-height:18px!important;margin:0!important}\n.dialog.notice.bar .message,.dialog.notice.bar .links{font-size:11px!important;line-height:15px!important}\n.dialog.notice.bar .actions{padding:0!important;margin:3px 0 0!important;gap:6px!important}\n.dialog.notice.bar .actions .group{display:grid!important;grid-template-columns:1fr 1fr!important;width:100%!important;gap:8px!important}\n.dialog.notice.bar .actions button{min-width:0!important;width:100%!important;min-height:36px!important;padding:7px 8px!important;font-size:12px!important;line-height:18px!important}\n}\n@media(max-width:749px){\n.dialog.notice.bar .intro{display:block!important}\n.dialog.notice.bar .intro .message,.dialog.notice.bar .intro .links{display:inline!important}\n.dialog.notice.bar .intro .links{margin-left:4px!important}\n.dialog.notice.bar .intro .links a{display:inline!important}\n}";
  const observed = new WeakSet();
  function attach() {
    document.querySelectorAll('pandectes-cmp').forEach(host => {
      const root = host.shadowRoot;
      if (!root) return;
      function apply() {
        if (root.getElementById(styleId)) return;
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = css;
        root.appendChild(style);
      }
      apply();
      if (!observed.has(root)) {
        observed.add(root);
        new MutationObserver(apply).observe(root, {childList:true});
      }
    });
  }
  function start() {
    attach();
    new MutationObserver(attach).observe(document.body, {childList:true});
    let attempts = 0;
    const timer = setInterval(() => { attach(); if (++attempts >= 30) clearInterval(timer); },250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
